import React from "react";

const ROWS = [
    {
        term: "Analytical bias",
        body: (
            <>
                The direction the model currently finds more evidence for. The BUY / SELL /
                HOLD label is an internal classification code — read it as <em>bullish</em>,{" "}
                <em>bearish</em>, or <em>neutral</em> research framing, not a trade
                instruction.
            </>
        ),
    },
    {
        term: "Confidence",
        body: (
            <>
                The strength of the model&apos;s classification based on the inputs available
                — <strong>not</strong> a forecast probability of price movement or trade
                success.
            </>
        ),
    },
    {
        term: "Scenario level",
        body: (
            <>
                An illustrative price reference matching the current model direction — for
                monitoring price behavior, not a buy/sell trigger.
            </>
        ),
    },
    {
        term: "Invalidation level",
        body: (
            <>
                The price level at which the current interpretation would weaken or no
                longer hold — useful for knowing when the read has structurally changed.
            </>
        ),
    },
    {
        term: "Horizon",
        body: (
            <>
                The window over which the current model reading is being framed — not a
                holding-period recommendation.
            </>
        ),
    },
];

/**
 * "How to read this report" — canned legend so every reader (including
 * those landing from a public share link) understands how to interpret
 * each module label.
 */
export default function HowToReadModule() {
    return (
        <section className="module p-6 md:p-10" data-testid="how-to-read-module">
            <p className="text-overline">How to read this report</p>
            <h2
                className="font-serif mt-2 mb-6"
                style={{ fontSize: "clamp(1.6rem, 3vw, 2.2rem)", letterSpacing: "-0.015em" }}
            >
                A quick legend.
            </h2>
            <dl className="space-y-4 text-sm leading-relaxed">
                {ROWS.map((r) => (
                    <div key={r.term} className="grid grid-cols-12 gap-3">
                        <dt
                            className="col-span-12 md:col-span-3 text-overline"
                            style={{ fontSize: "0.6rem", color: "hsl(var(--text-muted))" }}
                        >
                            {r.term}
                        </dt>
                        <dd className="col-span-12 md:col-span-9">{r.body}</dd>
                    </div>
                ))}
            </dl>
            <p
                className="mt-6 text-xs"
                style={{ color: "hsl(var(--text-muted))", lineHeight: 1.6, maxWidth: "70ch" }}
            >
                This output is generated by an AI model from publicly available market data.
                It is provided for informational and educational research use only, and does
                not constitute financial advice, investment advice, a solicitation, or a
                recommendation to buy, sell, or hold any security. Users should conduct their
                own research and, where appropriate, consult a licensed financial professional.
            </p>
        </section>
    );
}
